import React, { useState } from 'react';
import { AlertTriangle, Eye, EyeOff } from 'lucide-react';
import { OwnerButton, OwnerShell } from '../OwnerShell';
import { CheckRow, TextField } from '../OwnerFields';
import { fromBn } from '../../../utils/bn';
import type { OwnerNav } from '../../../types/owner';
const takenMobiles = ['01819223344', '01913445566', '01615998877'];
export function OwnerRegister({
  nav
}: {
  nav: OwnerNav;
}) {
  const [f, setF] = useState({
    name: 'মোঃ রহিম উদ্দিন',
    mobile: '০১৭১২৩৪৫৬৭৮',
    nid: '১৯৮৭৬৫৪৩২১০৯৮',
    dob: '১৫/০৫/১৯৮৭',
    pass: 'Rahim@2026',
    confirm: 'Rahim@2026'
  });
  const [agree, setAgree] = useState(false);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (k: keyof typeof f) => (v: string) => setF(s => ({
    ...s,
    [k]: v
  }));
  const duplicate = takenMobiles.includes(fromBn(f.mobile).replace(/\D/g, ''));
  const submit = () => {
    const e: Record<string, string> = {};
    const mobile = fromBn(f.mobile).replace(/\D/g, '');
    const nid = fromBn(f.nid).replace(/\D/g, '');
    if (f.name.trim().length < 3) e.name = 'পূর্ণ নাম লিখুন';
    if (!/^01[3-9]\d{8}$/.test(mobile)) e.mobile = 'সঠিক ১১ সংখ্যার মোবাইল নম্বর দিন (যেমন ০১৭XXXXXXXX)';else if (duplicate) e.mobile = 'এই মোবাইল নম্বরে ইতোমধ্যে একটি অ্যাকাউন্ট রয়েছে';
    if (![10, 13, 17].includes(nid.length)) e.nid = 'NID নম্বর ১০, ১৩ অথবা ১৭ সংখ্যার হতে হবে';
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(fromBn(f.dob))) e.dob = 'দিন/মাস/বছর ফরম্যাটে লিখুন';
    if (f.pass.length < 8) e.pass = 'কমপক্ষে ৮ অক্ষরের পাসওয়ার্ড দিন';
    if (f.pass !== f.confirm) e.confirm = 'পাসওয়ার্ড মেলেনি';
    if (!agree) e.agree = 'শর্তাবলিতে সম্মতি দিন';
    setErrors(e);
    if (Object.keys(e).length) return;
    nav.setOtpPurpose('register');
    nav.go('otp');
  };
  return <OwnerShell nav={nav} title="নতুন অ্যাকাউন্ট তৈরি করুন" subtitle="ধাপ ১/৩ • মৌলিক তথ্য" footer={<>
          <OwnerButton variant="green" onClick={submit} data-id="element-1937" data-mp="dcxrd7qv6mr8">নিবন্ধন করুন</OwnerButton>
          <p className="mt-2 text-center text-xs text-slate-500" data-id="element-1938" data-mp="df0dvhst5xr7">
            অ্যাকাউন্ট আছে? <button onClick={() => nav.reset('login')} className="font-semibold text-navy-700" data-id="element-1939" data-mp="8emip0cb2ial">লগইন করুন</button>
          </p>
        </>} data-id="element-1936" data-mp="21v0awprlncn7">
      <div className="space-y-3.5" data-id="element-1940" data-mp="3utp61o8ydbiy">
        <TextField id="r-name" label="পূর্ণ নাম" required value={f.name} onChange={set('name')} error={errors.name} hint="জাতীয় পরিচয়পত্র অনুযায়ী" data-id="element-1941" data-mp="3usmdzczw931g" />
        <TextField id="r-mob" label="মোবাইল নম্বর" required value={f.mobile} onChange={set('mobile')} error={errors.mobile} inputMode="tel" data-id="element-1942" data-mp="3lszamlnltn5r" />
        {duplicate && !errors.mobile && <p className="-mt-2 flex items-start gap-1.5 rounded-md bg-amber-50 p-2 text-[11.5px] text-amber-800" data-id="element-1943" data-mp="3gvh9hhftwc8b">
            <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-1944" data-mp="1f218prq11gzm" />এই নম্বরে ইতোমধ্যে অ্যাকাউন্ট রয়েছে। লগইন করুন অথবা পাসওয়ার্ড পুনরুদ্ধার করুন।
          </p>}
        <TextField id="r-nid" label="জাতীয় পরিচয়পত্র নম্বর" required value={f.nid} onChange={set('nid')} error={errors.nid} inputMode="numeric" data-id="element-1945" data-mp="1a13prcx70ix2" />
        <TextField id="r-dob" label="জন্মতারিখ" required value={f.dob} onChange={set('dob')} error={errors.dob} hint="দিন/মাস/বছর" data-id="element-1946" data-mp="1ml0rbv5nz4hx" />
        <div className="relative" data-id="element-1947" data-mp="1rd0wc20lcnld">
          <TextField id="r-pass" label="পাসওয়ার্ড" required type={show ? 'text' : 'password'} value={f.pass} onChange={set('pass')} error={errors.pass} hint="কমপক্ষে ৮ অক্ষর, একটি সংখ্যা রাখুন" data-id="element-1948" data-mp="1wblwk1fuf79t" />
          <button onClick={() => setShow(s => !s)} aria-label={show ? 'পাসওয়ার্ড লুকান' : 'পাসওয়ার্ড দেখুন'} className="absolute right-2 top-[30px] p-1.5 text-slate-400" data-id="element-1949" data-mp="13my85wzss1s1">
            {show ? <EyeOff className="h-4 w-4" data-id="element-1950" data-mp="18o42u0d0pz47" /> : <Eye className="h-4 w-4" data-id="element-1951" data-mp="1dlneqtm8tzsz" />}
          </button>
        </div>
        <TextField id="r-confirm" label="পাসওয়ার্ড নিশ্চিত করুন" required type={show ? 'text' : 'password'} value={f.confirm} onChange={set('confirm')} error={errors.confirm} data-id="element-1952" data-mp="1dirh76eb5d52" />
        <CheckRow checked={agree} onChange={setAgree} data-id="element-1953" data-mp="2oyg45xrkac5v">আমি প্রদত্ত তথ্যের সঠিকতা নিশ্চিত করছি এবং ব্যবহারের শর্তাবলিতে সম্মত।</CheckRow>
        {errors.agree && <p className="-mt-2 text-[11px] font-medium text-red-600" data-id="element-1954" data-mp="2ikivxzr2yi7a">{errors.agree}</p>}
        <p className="rounded-md bg-blue-50 p-2.5 text-[11px] leading-relaxed text-blue-800" data-id="element-1955" data-mp="2wjim5bu8r55k">প্রোটোটাইপ: ডুপ্লিকেট সতর্কতা দেখতে মোবাইল নম্বরে ০১৮১৯২২৩৩৪৪ লিখুন।</p>
      </div>
    </OwnerShell>;
}